<template>
  <div class="contain">
    <TencentMapLocation :key="timerKey"></TencentMapLocation>
    <SignCheckin v-if="checkinSelected"></SignCheckin>
    <SignCheckStatic v-if="!checkinSelected"></SignCheckStatic>
    <CheckInBottomFunc></CheckInBottomFunc>
  </div>
</template>

<script>
import TencentMapLocation from '../../components/checkin/TencentMapLocation.vue'
import CheckInBottomFunc from '../../components/checkin/signCheck/CheckInBottomFunc.vue'
import SignCheckin from '../../components/checkin/signCheck/SignCheckin.vue'
import SignCheckStatic from '../../components/checkin/signCheck/SignCheckStatic.vue'
export default {
  name: 'SignCheck',
  data() {
    return {
      timerKey: true,
      checkinSelected: true,
      nowDate: '',
    }
  },
  components: {
    TencentMapLocation,
    CheckInBottomFunc,
    SignCheckin,
    SignCheckStatic,
  },
  methods: {
    setFunc(selected) {
      this.checkinSelected = selected
    },
    setReloactionStatus() {
      this.timerKey = new Date().getTime()
    },
  },
  mounted() {
    this.$bus.$on('setSelected', this.setFunc)
    this.$bus.$on('callReloacation', this.setReloactionStatus)
  },
}
</script>

<style scoped>
</style>